import { ChatHeader } from '@components/chat/ChatHeader';
import { ChatInfo } from '@components/chat/ChatInfo';
import { ChatView } from '@components/chat/ChatView';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { GuestChatPageShell } from './GuestChatPageShell';

export const InvalidLinkPage = () => {
  const { t } = useTranslation('Communication');

  return (
    <GuestChatPageShell>
      <ChatView
        header={
          <ChatHeader title={t('comms/chatAccess/invalidLink.page.title')} />
        }
        messages={
          <Box sx={{ margin: 'auto' }}>
            <ChatInfo
              text={t('comms/chatAccess/invalidLink.chatInfo.description')}
            />
          </Box>
        }
      />
    </GuestChatPageShell>
  );
};
